import { render, staticRenderFns } from "./postService.vue?vue&type=template&id=2d2e9974&scoped=true"
import script from "./postService.vue?vue&type=script&lang=js"
export * from "./postService.vue?vue&type=script&lang=js"
import style0 from "./postService.vue?vue&type=style&index=0&id=2d2e9974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2e9974",
  null
  
)

export default component.exports